import { Component, Input } from '@angular/core';
import { ClioConstants } from "../../../models/clio-constants/clio-constants";
import { AuthService } from "../../../services/auth/auth.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../../stores/app.state";
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs";

@Component({
  selector: 'app-error-template',
  imports: [],
  templateUrl: './error-template.component.html',
  styleUrl: './error-template.component.scss'
})
export class ErrorTemplateComponent {
  @Input()
  errorMessage: string = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS;

  errorMessageTitle: string = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS_TITLE;

  constructor(private authService: AuthService, private store: Store<AppState>, private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    // this.errorMessage = window.history.state['message'] || this.errorMessage;
    this.activatedRoute.data.subscribe((data) => {
      this.errorMessage = data["message"];
    } );

    this.authService.startSessionPolling();
    this.authService.startSessionExpiryWatcher();

    // console.log(this.store.selectSignal(selectOauthCodeVerifierValue)())
    // console.log(this.store.selectSignal(selectOauthTokenValue)())

    switch (this.errorMessage) {
      case ClioConstants.NO_STATUS_FOUND:
        this.errorMessageTitle = ClioConstants.NO_STATUS_FOUND_TITLE;
        break;
      case ClioConstants.NO_RECORDS_FOUND:
        this.errorMessageTitle = ClioConstants.NO_RECORDS_FOUND_TITLE;
        break;
      case ClioConstants.CANT_COMPLETE_REQUEST:
        this.errorMessageTitle = ClioConstants.CANT_COMPLETE_REQUEST_TITLE;
        break;
      case ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS:
      default:
        this.errorMessageTitle = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS_TITLE;
        break;
    }

  }

  ngOnDestroy() {
    this.authService.stopSessionExpiryWatcher();
  }
}
